/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Carrier_Is_External_HintInputs */

const vi_shipping_carrier_is_external_hint = /** @type {(inputs: Shipping_Carrier_Is_External_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị vận chuyển bên ngoài (Viettelpost, GHTK, GHN…) tự vận hành. Kế toán được phép chuyển trạng thái giao vận cho đơn của các đơn vị này thay tài xế.`)
};

/**

* @param {Shipping_Carrier_Is_External_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shipping_carrier_is_external_hint = /** @type {((inputs?: Shipping_Carrier_Is_External_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Carrier_Is_External_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shipping_carrier_is_external_hint(inputs)
});